var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconConfigCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5914 14.9731L15.3422 13.8136C15.0263 13.6498 14.6345 13.738 14.4197 14.0153L13.5984 15.0739C12.7896 14.6454 12.1831 14.2295 11.4755 13.5237C10.7173 12.7676 10.3129 12.15 9.90858 11.3686L10.9574 10.5495C11.2354 10.3352 11.3238 9.94452 11.1596 9.62945L9.99704 7.39874C9.79486 7.00805 9.28941 6.88202 8.92296 7.12147L7.49505 8.0793C7.16651 8.30615 6.97697 8.68423 7.00225 9.07492C7.02752 9.47821 7.07806 9.99494 7.17915 10.3478C7.59614 11.9484 8.59441 13.5994 10.0097 14.9983C11.4123 16.3972 13.0676 17.3928 14.6724 17.8213C15.0263 17.9095 15.5443 17.96 15.9613 17.9978C16.3657 18.023 16.7574 17.8339 16.9722 17.4936L17.9073 16.0443C18.1095 15.6662 17.9705 15.1747 17.5914 14.9731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfigCall);
export default __webpack_public_path__ + "static/media/icon-config-call.948c27160b613d3eba3384f99b1a7bbe.svg";
export { ForwardRef as ReactComponent };